module.exports = __webpack_public_path__ + "static/media/cheers-end.ce5a709b.png";